<template>
    <div class="button-outline-rounded small text-center view-all" @click="deregister">
        Deregister
    </div>
</template>
<script>
import axios from 'axios';

export default {
    props: {
        buttonMode: Boolean,
    },
    mounted () {
        if (!this.buttonMode) {
            this.deregister();
        }
    },
    methods: {
        deregister () {
            // axios request to de register to go here
            const apiUrl = process.env.VUE_APP_APIADDRESS;
            const code = process.env.VUE_APP_APICODE;
            let authResponse = localStorage.getItem('hello');

            if (authResponse !== {}) {
                authResponse = JSON.parse(authResponse).adB2CSignInSignUp;

                const config = {
                    headers: { Authorization: `bearer ${authResponse.access_token}` },
                };
                axios
                    .post(`${apiUrl}/deactivate?code=${code}`, {}, config)
                    .then(() => {
                        this.$router.push('/');
                    })
                    .catch((error) => {
                        // eslint-disable-next-line
                        console.log(error);
                    });
            } else {
                this.$router.push('/?error="no-bearer-to-deactivate');
            }
        },
    },
};
</script>
